import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_117: FaireProductEntity = {
  token: "starter_collection_117",
  type: "product",
  name: "Afternoon Decaf",
  brandName: "Canyon Coffee",
  imageUrl:
    "https://cdn.faire.com/fastly/d9b73c9db86d6b2cd21380141b254c74cac8307b4ffad1f49cbfbffe47b6f783.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 22,
  msrpDollars: 44,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
